<template>
  <div>
    <el-dialog
      v-model="show" title="开户" :close-on-click-modal="false" @close="handleCancel"
    >
      <el-form v-loading="loading" :model="form" label-width="100px">
        <el-form-item prop="username" label="用户名" :rules="[{required:true,message:' '}]">
          <el-input v-model="form.username" placeholder="用户名" clearable />
        </el-form-item>
        <el-form-item prop="password" label="密码" :rules="[{required:true, trigger: 'blur'}]">
          <div class="generate-password">
            <el-input v-model.trim="form.password" placeholder="请生成密码" readonly />
            <el-button type="primary" link @click="form.password=$func.generatePassword()">
              生成密码
              <el-icon>
                <Refresh />
              </el-icon>
            </el-button>
          </div>
          <div class="tips">密码不允许输入，只能由系统生成，请点击生成密码</div>
        </el-form-item>
        <el-form-item prop="contacts" label="联系人" :rules="[{required:true,message:' '}]">
          <el-input v-model="form.contacts" placeholder="联系人" clearable />
        </el-form-item>
        <el-form-item prop="mobile" label="联系电话" :rules="[{required:true,message:' '}]">
          <el-input v-model="form.mobile" placeholder="联系电话" clearable />
        </el-form-item>
        <el-form-item v-if="options.includes('ads')" label="抖音竞价" required>
          <el-switch v-model="form.ads" size="small" :active-value="1" :unactive-value="0" />
        </el-form-item>
        <el-form-item
          v-if="tokenForm.parent_id !=2242 && tokenForm.uid != 2242 && form.ads == 1" prop="operating_model"
          label="运营模式" :rules="[{required:true,message:' '}]">
          <el-radio-group v-model="form.operating_model">
            <el-radio :value="1">代运营</el-radio>
            <el-radio :value="3">半运营</el-radio>
            <el-radio :value="0">自运营</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--        <el-form-item v-if="options.includes('adx')" label="信息流" required>-->
        <!--          <el-switch v-model="form.adx" size="small" :active-value="1" :unactive-value="0"/>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item v-if="options.includes('meta')" label="数字人" required>
                  <el-switch v-model="form.meta" size="small" :active-value="1" :unactive-value="0"/>
                </el-form-item>-->
        <el-form-item v-if="options.includes('bjh')" label="百家号" required>
          <el-switch v-model="form.bjh" size="small" :active-value="1" :unactive-value="0" />
        </el-form-item>
        <el-form-item v-if="options.includes('xhs')" label="小红书" required>
          <el-switch v-model="form.xhs" size="small" :active-value="1" :unactive-value="0" />
        </el-form-item>
        <!--        <el-form-item v-if="options.includes('tuwen')" label="抖音图文" required>
                  <el-switch v-model="form.tuwen" size="small" :active-value="1" :unactive-value="0"/>
                </el-form-item>-->
        <!--        <el-form-item v-if="options.includes('kuaishou')" label="快手" required>
                  <el-switch v-model="form.kuaishou" size="small" :active-value="1" :unactive-value="0"/>
                </el-form-item>-->
        <el-form-item v-if="options.includes('tkad')" label="TIKTOK" required>
          <el-switch v-model="form.tkad" size="small" :active-value="1" :unactive-value="0" />
        </el-form-item>
        <el-form-item v-if="options.includes('geo')" label="GEO" required>
          <el-switch v-model="form.geo" size="small" :active-value="1" :unactive-value="0" />
        </el-form-item>
        <el-form-item>
          <el-button style="margin-right:10px;" :disabled="loading" @click="handleCancel">取 消</el-button>
          <el-button type="primary" :loading="loading" @click="handleBeforeOk">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { postUserClients } from "@/api/sso/agent/clients";
import { useUserStore } from "@/store";
import { Refresh } from "@element-plus/icons-vue";


export default {
  components: { Refresh },
  data() {
    return {
      show: false,
      loading: false,
      form: { operating_model: 1, password: "" },
      tokenForm: {},
      options: [],
      whiteList: ["ads", "adx", "meta", "bjh", "xhs", "tuwen", "kuaishou", "tkad", "geo"]
    };
  },
  methods: {
    handleOpen() {
      this.loading = false;
      this.options = [];
      useUserStore().profilesUserInfo.products.forEach(item => {
        if (this.whiteList.includes(item.key)) {
          this.options.push(item.key);
        }
      });
      this.tokenForm = useUserStore().token;
      this.show = true;
      this.form = {
        operating_model: 1,
        ads: 0,
        adx: 0,
        meta: 0,
        bjh: 0,
        xhs: 0,
        tuwen: 0,
        kuaishou: 0,
        tkad: 0,
        geo: 0,
        password: ""
      };
    },
    handleCancel() {
      this.show = false;
    },
    handleBeforeOk() {
      if (this.loading) {
        return;
      }
      if (this.tokenForm.parent_id == 2242 || this.tokenForm.uid == 2242) {
        this.form.operating_model = 0;
      }
      if (this.form.ads == 0 && this.form.adx == 0 && this.form.meta == 0 && this.form.bjh == 0 && this.form.xhs == 0 && this.form.tuwen == 0 && this.form.kuaishou == 0 && this.form.tkad == 0 && this.form.geo == 0) {
        this.$message.error("至少选择开通一个产品");
        return;
      }

      this.loading = true;
      postUserClients({
        ...this.form,
        isMask: true,
        product_list: [
          { name: "ads", is_open: this.form.ads },
          { name: "adx", is_open: this.form.adx },
          { name: "meta", is_open: this.form.meta },
          { name: "bjh", is_open: this.form.bjh },
          { name: "xhs", is_open: this.form.xhs },
          { name: "tuwen", is_open: this.form.tuwen },
          { name: "kuaishou", is_open: this.form.kuaishou },
          { name: "tkad", is_open: this.form.tkad },
          { name: "geo", is_open: this.form.geo }
        ]
      }).then(() => {
        this.$message.success("保存成功");
        this.show = false;
        this.$emit("handleOk");
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.tips {
  margin-top: 4px;
  color: #e45851;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
}
</style>
